(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('clubAdminTransitionHook', clubAdminTransitionHook);

    var extend = angular.extend;

    clubAdminTransitionHook.$inject = ['$q', 'localStorageService', 'Club', 'user', 'defaultAdminClubIdStorageKey', 'clubAdminStateName'];
    function clubAdminTransitionHook($q, $localStorage, Club, user, storageKey, clubAdminStateName) {
        return {
            onStart: [{ to: isClubAdminPage }, startHook],
            onSuccess: [{ to: isClubAdminPage }, successHook],
        };

        function isClubAdminPage(state) {
            return state.data && state.data.requireAdmin && state.includes[clubAdminStateName];
        }

        function startHook(transition) {
            // Variables
            var params = transition.params(),
                clubIdParam = params.clubId,
                clubParam = clubIdParam && params.club;

            // Promise
            return isAdmin().then(ensureClub).then(redirectIfNeeded);

            ////////////////////////////////

            function isAdmin() {
                return user.isAdmin ? $q.resolve() : $q.reject();
            }

            function ensureClub() {
                var individualId = user.id,
                    clubId = clubIdParam || $localStorage.get(storageKey),
                    useFallback = !!!clubIdParam; // <== if clubId was not explicitly passed in, use localStorage clubId with a server-side fallback.

                return clubParam || Club.getAdminClub({ individualId: individualId, clubId: clubId, useFallback: useFallback }).$promise;
            }

            function redirectIfNeeded(club) {
                var target = transition.router.stateService.target;

                if (!clubParam) {
                    params = extend({}, params, { clubId: club.id, club: club });
                    return target(transition.to(), params, transition.options());
                }
            }
        }

        function successHook(transition) {
            $localStorage.set(storageKey, transition.params().clubId);
        }
    }
})();